<template>
  <div>
    <page-loading v-if="!item" />
    <page-title v-if="item" :title="pageTitle" />
    <subscription-fields :item="item" v-on:submit="onSubmit" v-on:cancel="onCancel" v-if="item" isUpdate="true" :is-editable="isEditable">
        <template v-slot:save>Save</template>
        <template v-slot:buttons>
          <b-button-group>
            <b-button type="button" variant="danger" @click="onDelete">Delete</b-button>
          </b-button-group>
        </template>
    </subscription-fields>
  </div>
</template>

<script>
import CrudOperationsMixin from '../Common/CrudOperationsMixin.js'

export default {
  name: "SubscriptionEdit",
  mixins: [CrudOperationsMixin],
  props: ['id'],
  data() {
    return {
      item: null
    };
  },
  computed: {
    pageTitle: function () {
      return 'Subscription: ' + this.item.station.name + ': ' + this.item.applicationUser.userName;
    },
    isEditable: function () {
      return this.$root.$data.authenticatedUser.roles.some(x => x == "SiteAdmin") || this.$root.$data.authenticatedUser.stationRoles.some(x => x.station.id == this.item.station.id && x.type == "STATION_HEAD");
    },
    isAddressEditable: function () {
      return this.$root.$data.authenticatedUser.roles.some(x => x == "SiteAdmin");
    }
  },
  methods: {
    load: function () {
      this.readQuery('/graphql/management', {
          query: `
            query ($id: ID) {
              subscription (id: $id) {
                id,
                trigger,
                concurrencyCheck,
                displayWeight,
                applicationUser {
                  id,
                  userName,
                  email
                },
                station {
                  id,
                  name
                }
              }
            }`,
          variables: {
            'id': this.id
          }
        }, (data) => {
          this.item = data.subscription;
        });
    },
    goBack() {
      if (this.$route.query.returnPage == 'station')
        this.$router.push('/station/' + this.item.station.id + '/edit#subscriptions');
      else if (this.$route.query.returnPage == 'applicationUser')
        this.$router.push('/applicationUser/' + this.item.applicationUser.id + '#subscriptions');
    },
    onCancel(evt) {
      this.goBack();
    },
    onSubmit(evt) {
      this.updateQuery('/graphql/management', {
        query: `
          mutation ($id: ID!, $subscription: SubscriptionUpdateInputOGT!) {
            updateSubscription(id: $id, subscription: $subscription) {
              id
            }
          }`,
        variables: {
          'id': this.item.id,
          'subscription': {
            id: this.item.id,
            concurrencyCheck: this.item.concurrencyCheck,
            stationId: this.item.station.id,
            applicationUserId: this.item.applicationUser.id,
            trigger: this.item.trigger,
            displayWeight: this.item.displayWeight
          }
        }}, () => {
          this.goBack();
        }, null, 'Subscriptions', this.item.applicationUser.email);
    },
    onDelete(evt) {
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete this subscription? "' + this.item.applicationUser.userName + '" will no longer get notifications for the station "' + this.item.station.name + '" or see this station on their My NAB page.', {
        title: 'Delete Subscription',
        okVariant: 'danger',
        okTitle: 'Yes',
        cancelTitle: 'No',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if (!value)
          return;

        this.deleteQuery('/graphql/management', {
          query: `
            mutation ($id: ID!) {
              deleteSubscription(id: $id) { 
                id
              }
            }`,
          variables: {
            'id': this.item.id,
          }}, () => {
            this.goBack();
          }, null, 'Subscription', this.item.applicationUser.email);
      });
    }
  },
  mounted () {
    this.load();
    // Use this instead of the previous line to test the "Loading" bar
    //window.setTimeout(this.load, 3000);
  }
};
</script>